import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import JsonCollapse from "../JsonCollapse";
import ContactSetEditor from "../../../Contacts/ContactSetEditor";
import { selectProjectUUID } from "../../../store/slices/projectSlice";
import {
  selectSendLists,
  setSendLists,
} from "../../../store/slices/sendListsSlice";

export default function ContactsAndGroups({ onSave, uuid, uuidType }) {
  const sendLists = useSelector(selectSendLists);
  const dispatch = useDispatch();
  const projectUUID = useSelector(selectProjectUUID);
  const [sendList, setSendList] = useState();
  const [contactSet, setContactSet] = useState();
  const [contactSets, setContactSets] = useState();

  const saveSendList = async () => {
    if (
      sendList?.add?.length > 0 ||
      contactSets?.length > 0 ||
      contactSet?.filters?.length > 0 ||
      sendLists.some((sl) => sl.uuid === uuid)
    ) {
      const bodyContent = {
        uuid,
        uuidType,
        projectUuid: projectUUID,
        contacts: sendList?.add,
        contactSets,
        filters: contactSet?.filters,
      };
      dispatch(
        setSendLists([
          ...sendLists.filter((sl) => sl.uuid !== uuid),
          bodyContent,
        ])
      );

      // update ContactSetUUID
      onSave?.();
    }
  };

  const getSendList = async () => {
    const data = sendLists.find((sl) => sl.uuid === uuid);
    setSendList({
      clearStatic: false,
      add: data?.contacts || [],
      remove: [],
    });
    setContactSet({ uuid, filters: data?.filters || [] });
    setContactSets(data?.contactSets || []);
  };

  const isFiltersValid = () => {
    const errors = [];

    contactSet?.filters.forEach((f) => {
      if (f.fields?.length === 0) {
        errors.push("No fields chosen. ");
      }
      if (
        f.valueType !== "now" &&
        f.valueType !== "fixed" &&
        !f.valueId?.trim()
      ) {
        errors.push("No value chosen. ");
      }
      if (
        f.valueType !== "now" &&
        f.valueType === "fixed" &&
        f.values.length === 0
      ) {
        errors.push("No value chosen. ");
      }
    });
    if (
      contactSet?.filters?.length &&
      !contactSet?.filters?.some((f) => f.valueType !== "fixed") &&
      !contactSet?.filters?.some((f) => f.timeZoneFrom !== "fixed") &&
      !contactSet?.filters?.some((f) => f.offsetFrom !== "fixed")
    ) {
      errors.push("No dynamic filter defined.");
    }
    return [...new Set(errors)];
  };

  const location = useLocation();

  useEffect(() => {
    saveSendList();
  }, [sendList, contactSet?.filters, contactSets]);

  useEffect(() => {
    getSendList();
  }, []);

  return (
    sendList &&
    contactSet &&
    contactSets && (
      <>
        {isFiltersValid().length > 0 && (
          <div className="alert alert-danger">{isFiltersValid()}</div>
        )}
        <ContactSetEditor
          isRuntimeContacts
          contactSet={contactSet}
          setContactSet={setContactSet}
          key={uuid}
          sendList={sendList}
          setSendList={setSendList}
          contactSets={contactSets}
          setContactSets={setContactSets}
          initialSearchType={location.state?.searchType}
        />
        <JsonCollapse json={{ contactSet, sendList, contactSets }} />
      </>
    )
  );
}
